export default "/fonts/vendor/@quasar/extras/fontawesome-v6/fa-regular-400.ttf?914997e1bdfc990d0897cdaba877a0b3";